<template>
  <div class="cotainer card-item">
    <div class="title-box">
      <span class="title-text">思政微课团队成员</span>
      <span
        v-if="isstatus"
        style="color: #d97706; font-size: 14px; font-weight: 400; margin-left: 8px"
      >
        <!-- 状态列标识新增/编辑/删除；待审核记录只能先撤销再改 -->
      </span>
      <span class="btn-action-group">
        <a-button
          type="primary"
          @click="addTeachers"
          class="btn-action"
          v-if="oldInfos?.id && !isEdit"
          >新增</a-button
        >
        <a-button
          @click="importsj()"
          v-if="oldInfos?.id && !isEdit"
          class="btn-action"
          >导入</a-button
        >
        <!-- <a-button
          class="btn-action"
          danger
          type="text"
          @click="batchDelete"
           v-if="(oldInfos?.id && !isEdit) && oldInfos?.auditState!='2'"
        >
          批量移除</a-button
        > -->
      </span>
    </div>
    <!-- <div class="title-boxs">
    <span class="btn-action-group"  v-if="(oldInfos?.id && !isEdit )">
        <a-button
          type="primary"
          @click="addTeachers"
          class="btn-action"
         
          >新增</a-button
        >
       <a-button @click="importsj()" class="btn-action" 
          >导入</a-button
        >
        <a-button
          class="btn-action"
          danger
          type="text"
          @click="batchDelete"
        >
          批量移除</a-button
        >
      </span>
    </div> -->
    <div class="cotainerfottter">
      <a-table
        style="text-align: center"
        :locale="{
          emptyText: oldInfos?.id ? '暂无数据' : '填写基本信息之后才能添加内容',
        }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        @change="handleTableChange"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
        :scroll="{ x: 1280 }"
        
      >
        <!-- :scroll="{ y: 290 }"
        :row-selection="rowSelection" -->
        <template slot="status" slot-scope="text, record, index">
          <!-- :defaultVisible="true" -->
          <a-tooltip placement="right" v-if="String(record.status) !== '2'">
            <template slot="title">
              <span v-if="record.operation == 'INSERT'">
                <div>新增当前数据</div>
                <div
                  v-for="item in insertDiff(record)"
                  :key="item.key || item.field"
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  {{ item.field }}：{{ item.obj2 }}
                </div>
              </span>
              <span v-if="record.operation == 'UPDATE'">
                <div
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  属性名称：原数据<span style="color: #3498db; font-size: 20px"
                    >→</span
                  >新数据
                </div>
                <div
                  v-for="item in diff(
                    record.changeTransContent,
                    record.nowTransContent
                  )"
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  {{ item.field }}:<span>{{ item.obj1 }}</span>
                  <span style="color: #3498db; font-size: 20px">→</span
                  ><span>{{ item.obj2 }}</span>
                </div>
              </span>
              <span v-if="record.operation == 'DELETE'">删除当前数据.</span>
              <span v-if="text == '3'">驳回原因:{{ record.remark }}</span>
            </template>
            <div class="statuswz">
              <img
                src="@/assets/images/newadd.png"
                v-if="record.operation == 'INSERT'"
                title="新增"
              />
              <img
                src="@/assets/images/newedit.png"
                v-if="record.operation == 'UPDATE'"
                title="编辑"
              />
              <img
                src="@/assets/images/newdelete.png"
                v-if="record.operation == 'DELETE'"
                title="删除"
              />
              <!-- <img src="@/assets/images/back.png" v-if="record.operation==''" title="正确" /> -->
              <img
                src="@/assets/images/right.png"
                v-if="record.operation == ''"
                title="正常数据"
              />
              <div class="status-code status-orange" v-if="text == '0'"></div>
              <div class="status-code" v-if="text == '1'"></div>
              <div class="status-code status-red" v-if="text == '3'"></div>
              <div class="status-code status-gray" v-if="text == '4'"></div>
            </div>
          </a-tooltip>
          <div class="statuswz" v-else>
            <img
              src="@/assets/images/right.png"
              v-if="record.operation == ''"
              title="正确"
            />
          </div>
        </template>
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="sex" slot-scope="text, record, index">
          <span v-if="text == '1'">男</span>
          <span v-else>女</span>
        </template>
        <template slot="izResponse" slot-scope="text, record, index">
          <span v-if="record.izResponse == '1'">是</span>
          <span v-else>否</span>
        </template>

        <span class="flex flex-around team-action-cell" slot="action" slot-scope="record">
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="oldInfos && oldInfos.id"
            @click="showevidence(record)"
          >
            <img class="img-box" src="../../assets/images/imgcl.png" alt="" />
            <span>佐证材料</span>
          </div>

          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="
              oldInfos &&
              oldInfos.id &&
              !isEdit &&
              record?.operation != 'DELETE' &&
              record?.status != '1' &&
              record?.status != '3'
            "
            @click="editInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="
              oldInfos &&
              oldInfos.id &&
              !isEdit &&
              !record?.operation
            "
            @click="deleteInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="oldInfos && oldInfos.id && !isEdit && record?.operation"
            @click="cancelInfo(record)"
          >
            <img class="img-box" src="@/assets/images/cx.png" alt="" />
            <span>撤销</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="oldInfos && oldInfos.id && isEdit"
            @click="seeInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>查看</span>
          </div>
        </span>
      </a-table>
    </div>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p v-if="sj?.status == '1'">您确定要移除待审核的这条数据吗?</p>
      <p v-else-if="sj?.status == '4'">您确定要移除已撤销的这条数据吗?</p>
      <p v-else>您确定要移除这位老师的数据吗?</p>
    </a-modal>
    <a-modal
      title="您确定撤销吗"
      :visible="showCancelModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOks"
      @cancel="showCancelModel = false"
    >
      <p v-if="sj?.status == '1'">您确定要撤销待审核的这条数据吗?</p>
      <p v-else-if="sj?.status == '3'">您确定要撤销已驳回的这条数据吗?</p>
      <p v-else>您确定要撤销当前提交的数据吗?</p>
    </a-modal>
    <!-- 添加老师 -->
    <add-teacher ref="addTeacher" @addTeacher="addTeacher"></add-teacher>
    <data-import ref="dataImport" @refreshData="addTeacher"></data-import>
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <evidencelist
          :title="title"
          :dataid="sj.id"
          :isEdit="isEdit"
          :id="id"
          @closePreview="showtable = false"
        >
        </evidencelist>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import dataImport from "@/components/common/dataImport.vue";
import evidencelist from "@/components/common/evidencelist";
import { FIELD_LABELS } from "@/components/auditPage/data.js";
import mixin from "@/utils/mixin";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "教师姓名",
    dataIndex: "teacherName",
    id: "teacherName",
    align: "center",
    width: 100,
  },
  {
    title: "性别",
    dataIndex: "sex",
    id: "sex",
    align: "center",
    width: 70,
    scopedSlots: { customRender: "sex" },
  },
  // {
  //   title: "生日",
  //   dataIndex: "birthday",
  //   id: "birthday",
  //   align: "center",
  //   width: 100,
  // },
  {
    title: "学历",
    dataIndex: "education_dictText",
    id: "education_dictText",
    align: "center",
    width: 100,
  },
  {
    title: "职称",
    dataIndex: "professionalTitle_dictText",
    id: "professionalTitle_dictText",
    align: "center",
    width: 100,
  },
  {
    title: "是否思政教师",
    dataIndex: "izPolitical_dictText",
    id: "izPolitical_dictText",
    align: "center",
    width: 130,
  },
  {
    title: "加入年份",
    dataIndex: "joinYear",
    id: "joinYear",
    align: "center",
    width: 100,
  },
  //  {
  //   title: "成员来源",
  //   dataIndex: "memberSource_dictText",
  //   id: "memberSource_dictText",
  //   align: "center",
  //   width: 100,
  //  },
  {
    title: "是否负责人",
    dataIndex: " izResponse",
    id: "izResponse",
    align: "center",
    scopedSlots: { customRender: "izResponse" },
    width: 120,
  },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 280,
    fixed: "right",
    scopedSlots: { customRender: "action" },
  },
];
import addTeacher from "./addTeamTeach.vue";
export default {
  mixins: [mixin],
  data() {
    return {
      dataList: [],
      loading: false,
      showDeleteModel: false,
      deteleId: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      columns: columns,
      selectedRowKeys: [],
      isEdit: false,
      showtable: false,
      id: "",
      title: "",
      sj: {},
      isstatus: false,
      showCancelModel: false,
      fieldLabels: FIELD_LABELS[3]["WKTUANDUI"],
      // isbjs:true,
    };
  },
  watch: {
    "oldInfos.id": {
      handler(newValue, oldValue) {
        console.log(newValue, "9999999999999999");
        if (newValue != null && newValue != undefined && newValue) {
          // this.oldInfos=newValue;
          // console.log(this.oldInfos.type);
          if (
            this.$route.query.new == "preview" ||
            this.resolveEditInfo().type == "preview" ||
            this.oldInfos?.type == "preview"
          ) {
            this.isEdit = true;
          }
          const role = this.$store.state.role;
          if (
            newValue &&
            this.isApplyPassed &&
            (role == "school-role" || role == "teacher-role")
          ) {
            const titleExists = this.columns.some(
              (column) => column.title === "状态"
            );
            this.isstatus = true;
            this.pagination = false;
            if (!titleExists) {
              const sj = {
                title: "状态",
                dataIndex: "status",
                id: "status",
                align: "center",
                scopedSlots: { customRender: "status" },
                width: 80,
                customCell: () => ({
                  style: { padding: "0", position: "relative" },
                }),
              };
              this.columns = [sj, ...columns.filter((item) => item.title !== "状态")];
            }
          } else {
            this.isstatus = false;
            this.columns = columns.filter((item) => item.title != "状态");
          }
          this.addTeacher();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
      immediate: true,
    },
    isbj: {
      handler(newValue, oldValue) {
        console.log(newValue, "我是");
        if (
          this.$route.query.new == "preview" ||
          this.resolveEditInfo().type == "preview" ||
          this.oldInfos?.type == "preview"
        ) {
          this.isEdit = true;
          return;
        }
        this.isEdit = newValue;
      },
      immediate: true,
    },
  },

  props: {
    oldInfos: {
      type: Object,
    },
    isbj: {
      type: Boolean,
      defalt: true,
    },
    /** 已通过项目发起变更时强制显示状态列（不依赖 $parent.editInfo） */
    showChangeStatus: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    addTeacher,
    dataImport,
    evidencelist,
  },
  computed: {
    isApplyPassed() {
      if (this.showChangeStatus) return true;
      return String(this.resolveEditInfo().auditState) === "2";
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        // 其他 row-selection 的配置
      };
    },
  },
  mounted() {
    this.isEdit = this.resolveEditInfo().type == "preview";
  },
  methods: {
    insertDiff(record) {
      if (record && record.nowTransContent) {
        return this.diff("{}", record.nowTransContent);
      }
      return this.diff("{}", JSON.stringify(record || {}));
    },
    resolveEditInfo() {
      if (this.oldInfos && (this.oldInfos.auditState != null || this.oldInfos.id)) {
        return this.oldInfos;
      }
      let p = this.$parent;
      for (let i = 0; i < 5 && p; i++) {
        if (p.editInfo) return p.editInfo;
        p = p.$parent;
      }
      return this.oldInfos || {};
    },
    cancelInfo(record) {
      this.showCancelModel = true;
      this.sj = record;
    },
    handleOks() {
      let data = {
        ids: this.sj.taskId,
      };
      const req =
        this.sj?.status == "1" || this.sj?.status == "3"
          ? postAction(
              "/audit/lxAuditTask/cancelTask?ids=" + this.sj.taskId,
              data
            )
          : deleteAction("/audit/lxAuditTask/deleteTaskAndDetail", {
              id: this.sj.taskId,
            });
      req.then((res) => {
        if (res.code === 200) {
          this.$message.success("撤销审核成功");
          this.showCancelModel = false;
          this.getData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    showevidence(record) {
      this.title = "思政微课团队成员";
      this.id = this.oldInfos.id;
      this.sj = record;
      this.showtable = true;
    },
    seeInfo(row) {
      this.$refs.addTeacher.init("see", row);
    },
    importsj() {
      this.$refs.dataImport.init("wkgroup", this.oldInfos, "思政微课团队成员");
    },
    handleOk() {
      if (
        this.sj?.status == "1" ||
        this.sj?.status == "4" ||
        this.sj?.status == "0" ||
        this.sj?.status == "3" ||
        (this.sj?.status == "2" && this.sj?.operation)
      ) {
        deleteAction("/audit/lxAuditTask/deleteTaskAndDetail", {
          id: this.sj.taskId,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("移除成功");
            this.showDeleteModel = false;
            this.getData();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        deleteAction("/lxBase/lxApplyGroup/delete", {
          id: this.deteleId,
          applyId: this.oldInfos?.id,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("移除成功");
            this.showDeleteModel = false;
            this.getData();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    addTeachers() {
      console.log("addTeachers this.oldInfos", this.oldInfos);
      this.$refs.addTeacher.init("add", this.oldInfos);
    },
    addTeacher() {
      if (!this.isstatus) {
        this.pagination.current = 1;
      }
      this.getData();
    },
    validate() {
      const list = this.dataList || [];
      if (!list.length) {
        this.$message.info("请添加团队成员");
        return false;
      }
      const requiredFields = [
        "teacherName",
        "sex",
        "birthday",
        "professionalTitle",
        "izPolitical",
        "izResponse",
        "joinYear",
        "memberSource",
      ];
      const fieldLabels = {
        teacherName: "教师姓名",
        sex: "性别",
        birthday: "出生日期",
        professionalTitle: "职称",
        izPolitical: "是否思政老师",
        izResponse: "是否负责人",
        joinYear: "加入年份",
        memberSource: "成员来源",
      };
      for (let i = 0; i < list.length; i++) {
        const row = list[i] || {};
        for (let j = 0; j < requiredFields.length; j++) {
          const field = requiredFields[j];
          const val = row[field];
          if (val === null || val === undefined || val === "") {
            this.$message.info(
              `第 ${i + 1} 行的${fieldLabels[field]}没有值，请填写`
            );
            return false;
          }
        }
      }
      return true;
    },
    getData() {
      // console.log("teaminfo this.oldInfos", this.oldInfos);
      //  console.log(this.oldInfos?.id,"1111");
      this.loading = true;
      if (this.isstatus && this.oldInfos?.id) {
        let data = {
          applyType: 3,
          // pageNo: this.pagination.current,
          // pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/lxBase/lxApplyGroup/allList", data).then((res) => {
          if (res.code === 200) {
            let data = res.result.records;
            if (data) {
              this.dataList = data;
              // this.pagination.total = res.result.total;
            }
          }
          this.loading = false;
        });
      } else {
        let data = {
          applyType: 3,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/lxBase/lxApplyGroup/list", data).then((res) => {
          if (res.code === 200) {
            let data = res.result.records;
            if (data) {
              this.dataList = data;
              this.pagination.total = res.result.total;
            }
          }
          this.loading = false;
        });
      }
    },
    deleteInfo(row) {
      this.showDeleteModel = true;
      this.sj = row;
      this.deteleId = row.id;
    },
    editInfo(row) {
      this.$refs.addTeacher.init("edit", row);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    option(type) {
      if (type === 1) {
        this.$emit("upStep", this.dataList);
      } else {
        this.$emit("downStep", this.dataList);
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      let applyType = 1;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量移除的教师");
      } else {
        let params = {
          ids: this.selectedRowKeys.toString(),
          applyId: this.oldInfos?.id,
        };
        deleteAction("/lxBase/lxApplyGroup/deleteBatch", params).then((res) => {
          if (res.code == 200) {
            this.$message.success("批量移除成功");
            this.pagination.current = 1;
            this.getData();
            this.selectedRowKeys = [];
            this.$forceUpdate();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.statuswz {
  width: 100%;
  height: 54px;
  line-height: 54px;
  cursor: pointer;

  img {
    width: 20px;
    height: auto;
    margin: 0px auto;
  }

  .status-code {
    width: 40px;
    height: 40px;
    background: url("~@/assets/images/green-sj.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: 0;
    top: 0;
  }
  .status-red {
    background: url("~@/assets/images/red-sj.png") no-repeat;
    background-size: 100% 100%;
  }
  .status-gray {
    background: url("~@/assets/images/hscx.png") no-repeat;
    background-size: 100% 100%;
  }
  .status-orange {
    background: url("~@/assets/images/dtj.png") no-repeat;
    background-size: 100% 100%;
  }
}
.cotainer {
  &.card-item {
    background: #ffffff;
    box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
    padding: 37px 20px;
    box-sizing: border-box;
    margin-bottom: 24px;
    .title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 700;
      border-bottom: 1px solid #d9d9d9;
      .title-text {
        color: #2155b5;
        font-size: 20px;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        border-bottom: 3px solid #2155b5;
        padding: 0px 4px;
      }
    }
  }
  .title-boxs {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 12px;
    font-size: 20px;
  }
  .btn-action {
    width: 100px;
    height: 30px;
    border-radius: 6px;
    font-weight: 400;
    cursor: pointer;
    line-height: 30px;
    margin-right: 10px;
    text-align: center;
  }
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}
.team-action-cell {
  flex-wrap: nowrap;
  white-space: nowrap;
  min-width: 260px;
}
.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
</style>
<style>
.ant-tooltip-arrow:before {
  background-color: #fff !important;
  width: 10px;
  height: 10px;
}

.ant-tooltip-inner {
  background-color: #fff !important;
  color: #3e3e3e !important;
  box-shadow: 0 0 12px 0 rgba(1, 39, 78, 0.27);
}
.ant-tooltip {
  max-width: 650px;
}
</style>